"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDatePickerButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DatePickerButtonMixin = require("../../mixins/components/DatePickerButtonMixin");
var _Button = require("../Button/Button");
var StyledDatePickerButton = /*#__PURE__*/(0, _styledComponents.default)(_Button.Button).withConfig({
  displayName: "StyledDatePickerButton",
  componentId: "c11n-8-107-0__sc-1fsqytd-0"
})(["", ""], _DatePickerButtonMixin.DatePickerButtonMixin);
exports.StyledDatePickerButton = StyledDatePickerButton;